import { connect } from 'react-redux';
import ButtonCreate from '../../components/ButtonCreate';

export default connect()(ButtonCreate);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ButtonCreate/index.tsx